import http from '@/communication/AuthConnection'
import MapAllSuppliers from './MapAllSuppliers'
import GroupSuppliers from './GroupSuppliers'

export default async ({ commit }, { eventId }) => {
  const { data } = await http.get(`/v1/quote/suppliers/${eventId}`)
  if (data) {
    const grouppedSuppliers = GroupSuppliers(data)

    commit('SET_LIST_ITEMS', {
      listItems: grouppedSuppliers
    })

    const suppliers = MapAllSuppliers(data)
    commit('SET_SUPPLIERS', suppliers)
    return data
  } else {
    return Promise.reject(Error('Não foi possível carregar a listagem'))
  }
}



// WEBPACK FOOTER //
// ./src/brain/quote/load-event-list/LoadEventList.js